import { WorkItemBase } from './workitem-base-model';
import { GenesysEmailWorkItem } from '../interfaces/genesys-email-item.interface';
import { WorkItemTypes } from '../constants/workitem-types';

export class WorkItemGenesysEmail extends WorkItemBase implements GenesysEmailWorkItem {
  readonly type: string = WorkItemTypes.GENESYS_EMAIL;
  isClosable = true;
  protected readonly _isCollapsible = true;

  constructor(id: string) {
    super({ id });
  }
}
